import script from "./ChangesList.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangesList.vue?vue&type=script&setup=true&lang=js"

import "./ChangesList.vue?vue&type=style&index=0&id=7d48b296&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d48b296"]])

export default __exports__